<template>
  <div class="custom-select" @click.stop="toggleDropdown">
    <div class="mask" v-if="isDropdownOpen"></div>
    <div class="selected-item">
      {{ selectedText || placeholder }}
      <span class="arrow" :class="{ 'arrow-rotate': isDropdownOpen }">
        <img src="../../assets/images/history/arrowRotate.svg">
      </span>
    </div>
    <transition name="fade">
      <div class="items" v-if="isDropdownOpen">
        <div
          v-if="items.length === 0"
          class="no-data"
        >
          No Data
        </div>
        <div
          v-else
          v-for="(item, index) in items"
          :key="index"
          @click.stop="selectItem(item, index)"
          :class="{ 'selected-item-bg': selectedIndex === index }"
        >
          {{ item.text }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CustomSelect',
  props: ['items', 'placeholder', 'defaultValue'],
  watch: {
    'items': function (arr) {
      this.selectItem(arr[this.selectedIndex], this.selectedIndex)
    }
  },
  data () {
    return {
      selectedText: '',
      isDropdownOpen: false,
      selectedIndex: null, // 新增属性，用于跟踪被选中的项的索引,
      currentItem: null
    }
  },
  methods: {
    toggleDropdown () {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    selectItem (item, index) {
      if (item) {
        this.selectedText = item.text
        this.isDropdownOpen = false
        this.selectedIndex = index // 更新选中项的索引
        this.$emit('selected', item)
        this.currentItem = item
      }
    },
    closeDropdown () {
      if (this.isDropdownOpen) {
        this.isDropdownOpen = false
      }
    }
  },
  mounted () {
    this.selectItem(this.defaultValue, 0)
    document.addEventListener('click', this.closeDropdown)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeDropdown)
  }
}
</script>

<style scoped>
.no-data {
  padding: 2vw; /* 8px / 3.6 */
  text-align: center;
  color: #999;
}

.custom-select {
  position: relative;
  cursor: pointer;
}

.selected-item {
  padding: 0 6.667vw 0 2.222vw; /* 8px 24px 8px 8px / 3.6 */
  background-color: rgb(47,47,47);
  border-radius: 0.833vw;
  position: relative;
  color: rgb(219,219,219);
  white-space: nowrap;
  letter-spacing: -0.025em;
}

.arrow {
  position: absolute;
  right: 2.222vw; /* 8px / 3.6 */
  top: 50%;
  transform: translateY(-50%) rotate(0deg);
  transition: transform 0.3s ease;
}

.arrow-rotate {
//transform: translateY(-50%) rotate(180deg);
}

.items {
  position: absolute;
  width:100%; /* 200px / 3.6 */
  background-color: rgb(47, 47, 47);
  border-radius: 0 0 0.833vw 0.833vw;
  z-index: 1000;
  overflow: hidden;
  color: #B7B7B7;
}

.items div {
  padding: 0 2.222vw; /* 8px / 3.6 */
  cursor: pointer;
}

.items div:hover {
  background-color: #5A5A5A;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
/* 新增样式，用于设置选中项的背景颜色 */
.selected-item-bg {
  background-color: #5A5A5A;
}
.mask{
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0,0,0,0.3);
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/Select/index.vue